// extracted by mini-css-extract-plugin
export var action_btn = "color_picker_scheme-module--action_btn--dc6d6";
export var actions_bar = "color_picker_scheme-module--actions_bar--99d91";
export var color_picker_scheme_wrapper = "color_picker_scheme-module--color_picker_scheme_wrapper--79540";
export var grid_colors = "color_picker_scheme-module--grid_colors--ce777";
export var main_color_preview = "color_picker_scheme-module--main_color_preview--cbee3";
export var picker_card = "color_picker_scheme-module--picker_card--1f3a5";
export var react_colorful = "color_picker_scheme-module--react_colorful--263d2";
export var react_colorful_input = "color_picker_scheme-module--react_colorful_input--80750";
export var react_colorful_last_control = "color_picker_scheme-module--react_colorful_last_control--42971";
export var schemes_page_subtitle = "color_picker_scheme-module--schemes_page_subtitle--c5946";
export var schemes_page_title = "color_picker_scheme-module--schemes_page_title--fcd35";
export var schemes_page_wrapper = "color_picker_scheme-module--schemes_page_wrapper--2667a";
export var shade_color = "color_picker_scheme-module--shade_color--e9084";
export var shades_grid = "color_picker_scheme-module--shades_grid--c7fc6";
export var shades_section = "color_picker_scheme-module--shades_section--adaef";
export var shades_title = "color_picker_scheme-module--shades_title--535c5";
export var title_card = "color_picker_scheme-module--title_card--144d3";
export var toast = "color_picker_scheme-module--toast--d3ca3";
export var toastIn = "color_picker_scheme-module--toastIn--3ca62";